export function convertToLocalTime(dateString: string) {
  const date = new Date(dateString);
  const localDate = date.toLocaleString();
  return localDate;
}
